import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { UserRequests } from '@base-api/user/user.requests';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private _account: any = {};

  constructor(
    private auth: AuthService,
    private api: UserRequests,
    @Inject(DOCUMENT) private document: Document
  ) { }

  get account() {
    return this._account || {};
  }

  set account(data) {
    this._account = data;
  }

  /**
   * Get logged user info
   */
  async me() {
    try {
      const user = await this.api.me().toPromise();
      if (user.user.isVisibilityOnlyUser) {
        this.document.location.href = "https://support.eyrus.com/hc/en-us/articles/360053508474";
        return;
      }
      this.auth.user = user;
      return this.auth.user;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
